import api from './api';

const userService = {
  getAllUsers: async () => {
    const response = await api.get('/users');
    return response.data.users;
  },

  getUserById: async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data.user;
  },

  createUser: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data.user;
  },

  updateUser: async (id, userData) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data.user;
  },

  deleteUser: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  }
};

export default userService;

